import { useEffect, useState } from 'react'
import './admin.styles.scss';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { faBasketball, faBug, faMouse, faSitemap, faUsers } from '@fortawesome/free-solid-svg-icons';
import UserListContainer from '@/components/ADMIN/manage-users/user-list-container.component';
import UserDetail from '@/components/ADMIN/manage-users/user-detail.component';
import AdminActivityLogs from '@/components/ADMIN/activity-logs/activity-logs.component';
import AdminBugReports from '@/components/ADMIN/bug-reports/bug-reports.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import Loader from '@/components/loader/loader.comp';
import AppShell from '@/components/SHARED/app-shell/app-shell.component';
import AdminScrimmage from '@/components/ADMIN/scrimmage/admin-scrimmage.component';
import LeaguesList from '@/components/ADMIN/leagues/leagues-list.component';
import CreateLeague from '@/components/ADMIN/leagues/create-league.component';
import LeagueDashboard from '@/components/ADMIN/leagues/league-dashboard.component';

const MENU = [
    { to: '/admin/leagues', label: 'Leagues', icon: faSitemap },
    { to: '/admin/scrimmage', label: 'Scrimmage Lab', icon: faBasketball },
    { to: '/admin/users', label: 'Users', icon: faUsers },
    { to: '/admin/bugs', label: 'Bug Reports', icon: faBug },
    { to: '/admin/logs', label: 'Activity Logs', icon: faMouse },
];

const AdminPage = () => {

    const [ admin, setAdmin ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function checkForAccess() {
            const adminTF = await UseCloudFunction('checkAdmin')
            if (!adminTF.success) {
                navigate('/home');
                return;
            }
            setAdmin(true)
        }
        checkForAccess();
    }, [navigate])

    if (!admin) return <div className='admin-loading'><Loader /></div>;

    return (
        <AppShell title='Admin' items={MENU} headLinks={[{ to: '/home', label: 'Home' }]} tabs={MENU.slice(0, 1)}>
            <Routes>
                <Route path='' element={<Navigate replace to='leagues' />}></Route>
                <Route path='leagues' element={<LeaguesList />}></Route>
                <Route path='leagues/new' element={<CreateLeague />}></Route>
                <Route path='leagues/:leagueId/*' element={<LeagueDashboard />}></Route>
                <Route path='scrimmage' element={<AdminScrimmage />}></Route>
                <Route path='users' element={<UserListContainer />}></Route>
                <Route path='users/:appId' element={<UserDetail />}></Route>
                <Route path='logs' element={<AdminActivityLogs />}></Route>
                <Route path='bugs' element={<AdminBugReports />}></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
        </AppShell>
    )
}

export default AdminPage
